module.exports = __webpack_public_path__ + "img/google_b2b.78607ec0.gif";